import {iconName, qualify, identifier} from '@packages/systems/wfdl-Qualified';
import {Plugins, withSystem, withMeta, Component} from '@packages/systems/wfdl';
import {
  TText,
  TRecord,
  EElement,
  ERecord,
  EText,
  EData,
  EFunction,
} from '@packages/systems/wfdl-ast';

export default Component.create({
  icon: qualify(Plugins.name('Basic'), iconName('Button')),
  // @ts-expect-error - TS2345 - Argument of type '{ icon: Qualified<string>; showEmpty: boolean; displayName: string; dataType: Type; render: ExpressionF<ExpressionF<ExpressionF<ExpressionF<unknown>>>>; }' is not assignable to parameter of type 'ComponentShape'.
  showEmpty: false,
  displayName: 'Submit Button Component',
  dataType: TRecord({
    value: withMeta(
      {placeholder: 'e.g. Submit'},
      withSystem(
        {
          defaultValue: 'Submit',
          label: 'Button',
          isLocalizable: true,
        },
        TText
      )
    ),
    'data-wait': withMeta(
      {placeholder: 'e.g. Please wait...'},
      withSystem(
        {
          defaultValue: 'Please wait...',
          label: 'Waiting',
          isLocalizable: true,
        },
        TText
      )
    ),
  }),
  defaultData: EFunction({
    param: identifier('context'),
    body: ERecord({
      value: EText('Submit'),
      'data-wait': EText('Please wait...'),
    }),
  }),
  render: EElement({
    id: 'form-button-component',
    type: qualify(Plugins.name('Form'), Component.name('FormButton')),
    data: ERecord({
      attr: ERecord({
        type: EText('submit'),
        value: EData(['value']),
        'data-wait': EData(['data-wait']),
      }),
      form: ERecord({
        type: EText('button'),
      }),
    }),
  }),
});
